import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const WoltIntegration = lazyWithRetry(() => import(/* webpackChunkName: "wolt-integration" */'../../component/WoltIntegration'))

const WoltIntegrationPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<WoltIntegration />
		</Suspense>
	)
})

WoltIntegrationPage.displayName = 'WoltIntegrationPage'
export default WoltIntegrationPage
